import { ArrowBack } from '@mui/icons-material';

import { IconButton } from '@mui/material';

import { ConfirmLoginByMFAForm } from '@features/auth/confirm-login-by-mfa';

import { trimPayload } from '@shared/lib/prototype';

import { createView } from '@shared/lib/view';

import { PageCenterLayout } from '@shared/ui';

import { confirmMFABackClicked } from '../model';

const ConfirmLoginMfaPage = createView()
  .props({ onBackClick: confirmMFABackClicked.prepend(trimPayload) })
  .view(({ onBackClick }) => (
    <PageCenterLayout
      before={
        <IconButton onClick={onBackClick}>
          <ArrowBack />
        </IconButton>
      }
    >
      <ConfirmLoginByMFAForm />
    </PageCenterLayout>
  ));

export { ConfirmLoginMfaPage };
